export enum TRACKING_ORDER_TYPE {
  ALL = 'all',
  DOMESTIC = 'domestic',
  INTERNATIONAL = 'international'
}
